import { render } from "./InfoMessageDisplayWidget.vue?vue&type=template&id=3db0d534&ts=true"
import script from "./InfoMessageDisplayWidget.ts?vue&type=script&lang=ts&external"
export * from "./InfoMessageDisplayWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__